import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-742c3e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar menu w-column-primary" }
const _hoisted_2 = { class: "persons" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "topbar w-column-aux" }
const _hoisted_6 = { class: "console" }
const _hoisted_7 = { class: "topbar-menu menu-box" }
const _hoisted_8 = { class: "menu-box-buttons" }
const _hoisted_9 = {
  key: 1,
  class: "menu-box-projects"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "menu-box-persons" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "menu-box-nav" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, " Help", -1))

import { useAppContext } from '@/app/_tech';
import { onMounted, onUnmounted, reactive, ref } from 'vue';
import { RouteLocationRaw, useRouter } from 'vue-router';
import { computed } from 'vue';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { ProjectModel } from '@/app.context/workspace/project.rmodel';
import sys from '@/sys';

import { dragEventRef } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'
import { TqueuePosition } from '@/logic/_infra/queues';
import { personStateCss } from '@/controllers/workspaces/person.controller';

import ConsoleComponent from '@/components/lib/ConsoleComponent.vue';

type WorkspacePage = "status" | "reports" | "settings" | "calendar"


export default /*#__PURE__*/_defineComponent({
  __name: 'TopbarControl',
  emits: ['command'],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter()

//const props = defineProps<{workspace:string, project:string}>()
const context = useAppContext();

const model = reactive({ menu: false });

const projects = computed(() => { return f.projects() })

//returns persons excluding current - for navigation bar
const persons = computed(() => { return f.persons() })

const person_title = computed(() => { return f.persons()[0] })

const personsAll = computed(() => { return f.personsAll() })


function isPersonBoardView(p:PersonRmodel){

        return p == context.cursor?.person && context.cursor.person_code == null
}

function isPersonAuxView(p:PersonRmodel){

return p == context.cursor?.person && context.cursor.person_code != null
}

const projectIsSingle = computed(() => {

        const b = f.projects();

        if (b.length === 1) return b[0]; else return null;
})

const f =
{
        persons() { return context.cursor.workspace?.persons(/*context.cursor?.person ?? undefined*/) ?? [] },
        projects() { return context.cursor.workspace?.projects(/*context.cursor?.project ?? undefined*/) ?? [] },
        personsAll() { return context.cursor.workspace?.persons() ?? [] },
}


//const textbox = ref<InstanceType<typeof HTMLInputElement> | null>(null)

const consoleComponent = ref<InstanceType<typeof ConsoleComponent> | null>(null)

const emit = __emit

__expose({ console, consoleClear, focus })

function focus() {

        const c = consoleComponent.value

        if (c != null) c.focus()
}

function console() {

        const c = consoleComponent.value

        if (c != null) return c.consoleContent(); else return ''

        
}

function consoleClear() {

        const c = consoleComponent.value

        if (c != null) c.consoleClear()


        //return consoleContentClear()
}

function navigate(to: RouteLocationRaw) {

        model.menu = false;

        router.push(to)
}

function logoff() {

        context.logoff();

        navigate({ name: 'home' });
}

function navigatePerson(p: PersonRmodel, alternativePath: boolean) {

        const w = context.cursor.workspace;

        if (w != null) {

                if (!alternativePath) navigate({ name: 'person', params: { workspace: w.name, person: p.name } })
                else navigate({ name: 'person-timeline', params: { person: p.name, workspace: p.workspace.name } })


        }
}

function navigateTicket(n: number) {

        const w = context.cursor.workspace;

        if (w != null) {

                navigate({ name: 'ticket', params: { ticket: n, workspace: w.name } })
        }
}

function navigatePage(p: WorkspacePage) {
        const w = context.cursor.workspace;

        //<span><router-link :to="{name:'settings', params:{workspace:props.workspace}}">[settings]</router-link></span> -->

        if (w != null) navigate({ name: p, params: { workspace: w.name } })
}

function navigateProject(p: ProjectModel) {

        const w = context.cursor.workspace;

        if (w != null) navigate({ name: 'project', params: { workspace: w.name, project: p.name } })

        //:to="" >
}

function navigateUp() {
        const w = context.cursor.workspace;

        if (context.cursor.project != null) navigate({ name: 'home' }); //from project level go up to 'workpsaces'
        if (context.cursor.person != null) {

                const p = w?.project_default();

                

                if (p != null) navigateProject(p);
                else sys.info('Cant navigate')
        }

        
}

// function esc(args: KeyboardEvent) {

//         //sys.info(args.code) //Slash

//         if (args.code == 'Escape') {

//                 consoleContentClear()
//                 args.preventDefault()
//         } 

//         //args.preventDefault()
// }

function submit(v:string) {

        //const v = consoleContent();

        //if console content is clear @person
        //if person exists - navigate there
        //if person not exists - create it and navigate - may be implement later - after 'decline' procedure clear



        const regex_person = /^@([\w]+)$/
        const regex_number = /^#{0,1}([1-9][\d]*)$/



        //if conseol conte is clear '#1' - ticket number or just '1'

        if (v != '') {

                if (regex_person.test(v)) {


                        const m = v.match(regex_person)


                        //const matches = regex_person.match(v)

                        const name = m![1]

                        const w = context.cursor.workspace;

                        if (w!.index.persons.has(name)) navigatePerson(w!.index.persons.get(name)!, false)

                        else sys.info(`Create person ${name}`)

                        //consoleContentClear()
                }
                else if (regex_number.test(v)) {

                        const matches = v.match(regex_number)

                        const n = parseInt(matches![1])

                        const w = context.cursor.workspace;

                        if (w!.index.tickets.has(n)) navigateTicket(n)

                        //consoleContentClear()
                }
                else {

                        emit('command', v)

                        //consoleContentClear();
                }

        }
}

// function consoleContent(): string {

//         if (textbox.value != null) {

//                 const t = textbox.value;

//                 return t.value;
//         }
//         else sys.warn("Can't find console element at page")

//         return ''
// }

// function consoleContentClear() {

//         if (textbox.value != null) {

//                 const t = textbox.value;
//                 t.value = ''
//         }
//         else sys.warn("Can't find console element at page")
// }

function onDrop_Logo(e: DragEvent) {

        const ref = dragEventRef(e)

        if (ref != null) {
                const w = context.cursor.workspace!

                const ticket = w.ticket(ref.n)

                const p = w.project_default()

                context.ops.xbq!.queue(ticket, p, new TqueuePosition("queue", 0))
        }
        else sys.warn('/topbar/logo - Ref on drop is null')

        const t = e.target as HTMLElement

        if (t != null) t.classList.remove('tech-dropable')
}

function onDragOver_Logo(e: DragEvent) {

        if (!context.isCaptain()) return

        //e.dataTransfer is not filled until drop? const ref = dragEventRef(e)

        //if (ref != null) e.preventDefault()

        e.preventDefault()
}

onMounted(()=>{

        context.prompt = function(){

                const buffer = console()

                consoleClear()

                return buffer
        }
})

onUnmounted(()=>{

        context.prompt = undefined
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        id: "mn-workspace-logo",
        class: "logo clickable",
        onClick: navigateUp,
        onDrop: onDrop_Logo,
        onDragover: onDragOver_Logo
      }, null, 32),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("i", {
          class: "bi-stopwatch clickable",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (navigatePerson(person_title.value, true)))
        }, null, 512), [
          [_vShow, !isPersonAuxView(person_title.value)]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(persons.value, (p, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: p.name
          }, [
            (i != 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" •")
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              onClick: ($event: any) => (navigatePerson(p, isPersonBoardView(p))),
              class: _normalizeClass(["clickable", { active: p == _unref(context).cursor?.person }])
            }, [
              _createTextVNode(_toDisplayString(p.name) + " ", 1),
              _withDirectives(_createElementVNode("i", {
                class: _normalizeClass(["bi bi-exclamation-square", _unref(personStateCss)(p)])
              }, null, 2), [
                [_vShow, p.status() != 'normal']
              ])
            ], 10, _hoisted_3)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "bi bi-house-door",
          onClick: navigateUp,
          onDrop: onDrop_Logo,
          onDragover: onDragOver_Logo
        }, null, 32),
        _createElementVNode("span", {
          class: "bi-list",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (model.menu = !model.menu))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ConsoleComponent, {
          onSubmit: submit,
          ref_key: "consoleComponent",
          ref: consoleComponent
        }, null, 512)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      (projectIsSingle.value != null)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "bi-house-door left clickable",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateProject(projectIsSingle.value!)))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("i", {
        class: "bi-x-lg right clickable",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (model.menu = false))
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("i", {
          class: "bi-card-checklist clickable",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (navigatePage('status')))
        }),
        _createElementVNode("i", {
          class: "bi-calendar-event clickable",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (navigatePage('calendar')))
        }),
        _createElementVNode("i", {
          class: "bi-search clickable",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (navigatePage('reports')))
        }),
        _createElementVNode("i", {
          class: "bi-gear clickable",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (navigatePage('settings')))
        })
      ]),
      (projectIsSingle.value == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (p, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: p.name
              }, [
                (i > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" | ")
                    ], 64))
                  : _createCommentVNode("", true),
                (p.name != '')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "clickable",
                      onClick: ($event: any) => (navigateProject(p))
                    }, _toDisplayString(p.name), 9, _hoisted_10))
                  : (_openBlock(), _createElementBlock("i", {
                      key: 2,
                      class: "bi-house-door clickable",
                      onClick: ($event: any) => (navigateProject(p))
                    }, null, 8, _hoisted_11))
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personsAll.value, (p, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: p.name
          }, [
            (i != 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" •")
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              onClick: ($event: any) => (navigatePerson(p, false)),
              class: "clickable"
            }, "@" + _toDisplayString(p.name), 9, _hoisted_13)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (navigate({ name: 'home' })))
        }, "Workspaces"),
        _createTextVNode(" • "),
        _createElementVNode("a", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (navigate({ name: 'account' })))
        }, "Account"),
        _createTextVNode(" • "),
        _hoisted_15,
        _createTextVNode(" • "),
        _createElementVNode("a", { onClick: logoff }, "Log Out")
      ])
    ], 512), [
      [_vShow, model.menu]
    ])
  ]))
}
}

})